import { LitElement, css, html } from "lit";
export class MerSpinner extends LitElement {
    static styles = css `:host{--spinner-size:var(--size-16);--spinner-color:var(--color-border-primary-light);--track-color:var(--color-border-primary-pressed);--border-thinness:7;inline-size:var(--spinner-size);block-size:var(--spinner-size);border:calc(var(--spinner-size)/ var(--border-thinness)) solid var(--track-color);border-block-start:calc(var(--spinner-size)/ var(--border-thinness)) solid var(--spinner-color);border-radius:50%;animation:spin var(--timing-regular,1s) linear infinite}@keyframes spin{100%{transform:rotate(360deg)}}`;
    render() {
        return html ``;
    }
}
if (!customElements.get("mer-spinner")) {
    customElements.define("mer-spinner", MerSpinner);
}
